import { CircularProgress, Box } from '@material-ui/core';

export default function Loading() {
  return (
    <>
      <CircularProgress />
    </>
  );
}
